import React from 'react';
import { Progress, Tooltip, Icon } from 'antd';
import styles from './BudgetIndicator.module.scss';

function BudgetIndicator({
  currentBudgetInfo,
  label = 'My Credits',
  postBudgetCappingRequest,
  isUserBudgetCappingEnabled,
  postCreditsRequestApiStatus,
}) {
  if (!currentBudgetInfo.TotalBudget) {
    return null;
  }
  const {
    TotalBudget: totalBudget,
    AvailableBudget: availableBudget,
    RequestStatus: requestStatus,
  } = currentBudgetInfo || {};
  const usedBudget = totalBudget - availableBudget;
  const percentage = (usedBudget / totalBudget) * 100;

  let progressBarColor = '#2d2e67';
  if (percentage >= 75) {
    progressBarColor = '#F75656';
  } else if (percentage >= 50) {
    progressBarColor = '#FFAB1F';
  }

  const handleRequestCreditsClick = e => {
    e.stopPropagation();
    postBudgetCappingRequest(null, totalBudget);
  };

  if (!isUserBudgetCappingEnabled) {
    return null;
  }
  const isPending = requestStatus === 'Pending';

  return (
    <div className={styles.budgetIndicatorContainer}>
      <div className={styles.budgetIndicator}>
        <div className={styles.budgetHeader}>
          <span className={styles.budgetLabel}>{label}</span>
          <span className={styles.budgetValue}>
            {usedBudget}/{totalBudget}
          </span>
        </div>
        <Progress percent={percentage} strokeColor={progressBarColor} showInfo={false} size="small" />
      </div>
      <div className={styles.creditsRequest}>
        {postCreditsRequestApiStatus === 'INPROGRESS' ? (
          <div key="loader">
            <Icon type="loading" spin />
          </div>
        ) : (
          <Tooltip title={isPending ? 'Credit request is pending approval' : ''}>
            <div
              className={`${styles.requestCreditsLink} ${isPending ? styles.disabled : ''}`}
              onClick={isPending ? null : handleRequestCreditsClick}
              style={{ cursor: isPending ? 'not-allowed' : 'pointer' }}
            >
              Request credits
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
}

export default BudgetIndicator;
